import i18n from './i18n';
export default {
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
  SERVER_URL: process.env.VUE_APP_SERVER_URL,
  PUSHER_APP_KEY: process.env.VUE_APP_PUSHER_APP_KEY,
  PUSHER_APP_CLUSTER: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  AVAIL_APP_URL: process.env.VUE_APP_AVAIL_APP_URL,
  AVAIL_APP_DOMAIN: process.env.VUE_APP_AVAIL_APP_DOMAIN,
  AVAIL_APP_PROTOCOL: process.env.VUE_APP_AVAIL_PROTOCOL,
  NODE_ENV: process.env.VUE_APP_NODE_ENV,
  API_DOMAIN: process.env.VUE_APP_API_DOMAIN,
  PUSHER_APP_DOMAIN: process.env.VUE_APP_PUSHER_DOMAIN,
  PUSHER_APP_PORT: process.env.VUE_APP_PUSHER_APP_PORT,
  APP_VERSION: process.env.VUE_APP_BUILD_VERSION,
  IFA_LOGO: process.env.VUE_APP_SERVER_URL +
    'generic-thumbnails/Movies-Everywhere_Logo.png',
  VUE_APP_URL: process.env.VUE_APP_URL,

  VIMEO_ACCESS_TOKEN: '295d44c623f68a90cacc8a4826e1bf73',

  GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
  /* Layouts of app */

  STRIPE_KEY: process.env.VUE_APP_STRIPE_KEY,
  FIREBASE_DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
  WHITELABEL_MACHINE_IP: process.env.VUE_APP_WHITELABEL_MACHINE_IP,

  USE_ROOT: {root: true},
  LAYOUT_AUTH: 'LAYOUT_AUTH',
  LAYOUT_APP: 'LAYOUT_APP',
  LAYOUT_ADMIN: 'LAYOUT_ADMIN',

  SNACKBAR_SUCCESS_COLOR: 'success',
  SNACKBAR_ERROR_COLOR: 'error',

  HELP_TOOLTIP_MAX_WIDTH: '300px',

  AGREEMENT_TYPE_STR: {0: 'Right Holder', 10: 'Buyer'},

  AGREEMENT_TYPE: [
    {
      text: 'Right Holder',
      value: 0,
    },
    {
      text: 'Buyer',
      value: 10,
    },
  ],

  AGREEMENT_STATUS: [
    {
      text: 'Draft',
      value: 10,
    },
    {
      text: 'Negotiation',
      value: 20,
    },
    {
      text: 'Active',
      value: 50,
    },
    {
      text: 'Expired',
      value: 100,
    },
  ],

  AGREEMENT_STATUS_STRING: {
    10: 'Draft',
    20: 'Negotiation',
    30: 'Approved',
    50: 'Active',
    100: 'Expired',
  },

  AVAIL_LINKS_STATUS_STRING: {
    10: 'Active',
    20: 'Expired',
  },

  AVAIL_LINKS_STATUS_INT: {
    ACTIVE: 10,
    EXPIRED: 20,
  },

  AGREEMENT_STATUS_INT: {
    DRAFT: 10,
    NEGOTIATION: 20,
    APPROVED: 30,
    ACTIVE: 50,
    EXPIRED: 100,
  },

  DEFAULT_AGREEMENT_STATUS: 10, //DRAFT

  COLLECTION_UPLOADS: 'uploads',
  COLLECTION_ASSETS: 'assets',
  COLLECTION_DELIVERY: 'delivery',
  COLLECTION_DOCUMENTS: 'documents',

  MEDIA: {
    FILM: {
      SCREENERS: 'screeners',
      TRAILERS: 'trailers',
      ASSETS: 'assets',
      DELIVERABLES: 'deliverables',
      THUMBS: 'thumbs',
      POSTERS: 'Posters',
    },
  },

  MIME_TYPE: {
    IMAGE: 'image',
    VIDEO: 'video',
    APPLICATION: 'application',
    VTT: 'vtt',
    ALL: 'all',
  },

  MIME_TYPES: [
    {
      text: 'Image',
      value: 'image',
      icon: '$vuetify.icons.rms_image',
    },
    {
      text: 'Video',
      value: 'video',
      icon: '$vuetify.icons.rms_video',
    },
    {
      text: 'Application',
      value: 'application',
      icon: '$vuetify.icons.rms_rights',
    },
  ],

  MODEL_FILM: 'film',
  MODEL_AGREEMENT: 'agreement',
  MODEL_MEDIA: 'media',
  MODEL_TERRITORIES: 'territories',

  TAG_TYPE: {
    FOR_FILM_GENRE: 'film_genre',
    FOR_FILM_MEDIA: 'film_media',
    FOR_RIGHTS: 'film_rights',
    FOR_TERRITORIES: 'territories',
    FOR_LANGUAGES: 'languages',
    FOR_FILM_TYPE: 'film_type',
    FOR_FILM_FORMAT: 'film_format',
    FOR_MEDIA_RANDOM: 'media_random',
    FOR_FILM_RANDOM: 'film_random',
    FOR_FILM_ARTIST: 'film_artist',
  },
  TAG_STATUS: [
    {
      text: 'Publish',
      value: true,
    },
    {
      text: 'Unpublish',
      value: false,
    },
  ],
  //role of company users
  ROLE_BUYER: 110,
  ROLE_RIGHT_HOLDER: 120,
  ROLE_MEMBER: 130,
  ROLE_ADMIN: 140,
  ROLE_OWNER: 150,

  ROLE_STR: {
    110: 'Buyer',
    120: 'Right Holder',
    130: 'Member',
    140: 'Admin',
    150: 'Owner',
  },
  COMPANY_USER_ROLE: [
    // {
    //   text: 'Buyer',
    //   value: 110,
    // },
    {
      text: 'Right Holder',
      value: 120,
    },
    {
      text: 'Tickets Moderator',
      value: 130,
    },
    {
      text: 'Admin',
      value: 140,
    },
  ],
  // user roles
  USER_ROLE_USER: 10,
  USER_ROLE_ADMIN: 30,
  USER_ROLE_SUPER_ADMIN: 50,

  USER_ROLE_STR: {
    10: 'User',
    30: 'Admin',
    50: 'Super Admin',
  },

  ADMIN_THEME_COLOR: 'success',

  SUBSCRIPTION_MAX_PLAN_COUNT: 3,
  SUBSCRIPTION_STATUS_TRIALING: 120,
  SUBSCRIPTION_STATUS_ACTIVE: 130,
  SUBSCRIPTION_STATUS_CANCELED: 140,
  SUBSCRIPTION: {
    STATUS: {
      TRIALING: 'trialing',
      CANCELED: 'canceled',
      ACTIVE: 'active',
    },
    INVOICE: {
      STATUS: {
        PAID: 'paid',
        DUE: 'due',
        DRAFT: 'draft',
      },
    },
  },
  SESSION_MODE_SUPER_ADMIN: 'super_admin',
  ERROR_TYPE: {
    INVALID_AUTHENTICATION: 419,
    PRECONDITION_REQUIRED: 1028,
  },
  ALL: -1,
  SK_MEDIA_TOKEN: 'skMediaAccessToken',
  SCREENING_SCHEDULE_TYPES: [
    {
      text: 'All',
      value: 'all',
      icon: '$vuetify.icons.rms_image',
    },
    {
      text: 'Ongoing & Upcoming',
      value: 50,
      icon: '$vuetify.icons.rms_rights',
    },
    {
      text: 'Ongoing Screenings',
      value: 40,
      icon: '$vuetify.icons.rms_rights',
    },
    {
      text: 'Upcoming Screenings',
      value: 30,
      icon: '$vuetify.icons.rms_rights',
    },
    {
      text: "Today's Screenings",
      value: 20,
      icon: '$vuetify.icons.rms_image',
    },
    {
      text: 'Archive Screenings',
      value: 10,
      icon: '$vuetify.icons.rms_video',
    },
  ],
  LOCALES: [
    {
      text: 'Hebrew',
      value: 'he',
    },
    {
      text: 'English',
      value: 'en',
    },
    {
      text: 'Spanish',
      value: 'es',
    },
    {
      text: 'Italian',
      value: 'it',
    },
  ],
  ENCODING_STATUS: {
    ERROR: 'ERROR',
    NONE: 'NONE',
    DOWNLOADED: 'DOWNLOADED',
    ENCODING: 'ENCODING',
    ENCODED: 'ENCODED',
    REQUESTED: 'REQUESTED',
  },

  THEME: {
    PLATFORM: {
      COLORS: {
        PRIMARY: '#fc9345',
        SECONDARY: '#445878',
        BACKGROUND: '#fafafa',
      },
      RTL: false,
      LOCALE: 'en',
    },
  },

  SCREENER_STATUS: {
    0: 'Unpublished',
    1: 'Published',
  },

  ACCEPT_IMAGES: 'image/*',
  ACCEPT_MP4_MOV: 'video/mp4,video/mov',
  COLLECTION_PUBLIC: 'public',
  COLLECTION_PRIVATE: 'private',
  SUPPORT_EMAIL: 'support@filmdiy.com',

  GEO_BLOCKING: {
    TYPE: {
      BLACKLIST: 10,
      WHITELIST: 20,
    },
    FOR: {
      COUNTRIES: 10,
      CITY: 20,
    },
  },

  DEFAULT_FONTS : {
    text: 'Alef',
    value: 'Alef',
    url: 'https://fonts.gstatic.com/s/alef/v12/FeVfS0NQpLYgrjJbC5FxxbU.ttf'
  },
  FONT_FAMILIES:[
    {
      text: 'Alef',
      value: 'Alef',
      url: 'https://fonts.gstatic.com/s/alef/v12/FeVfS0NQpLYgrjJbC5FxxbU.ttf'
    },
    {
      text: 'Lato',
      value: 'Lato',
      url: 'https://fonts.gstatic.com/s/lato/v18/S6uyw4BMUTPHvxk6XweuBCY.ttf'
    },
    {
      text: 'Abhaya Libre',
      value: 'Abhaya Libre',
      url: 'https://fonts.gstatic.com/s/abhayalibre/v6/e3tmeuGtX-Co5MNzeAOqinEge0PWovdU4w.ttf'
    },
    {
      text: 'Merriweather',
      value: 'Merriweather',
      url: 'https://fonts.gstatic.com/s/merriweather/v23/u-440qyriQwlOrhSvowK_l5OeyxNV-bnrw.ttf'
    },
    {
      text: 'Alegreya',
      value: 'Alegreya',
      url: 'https://fonts.gstatic.com/s/alegreya/v19/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI_KCisSGVrw.ttf'
    },
    {
      text: 'Montserrat',
      value: 'Montserrat',
      url: 'https://fonts.gstatic.com/s/montserrat/v16/JTUSjIg1_i6t8kCHKm45xW5rygbi49c.ttf'
    },
    {
      text: 'Aleo',
      value: 'Aleo',
      url: 'https://fonts.gstatic.com/s/aleo/v4/c4mv1nF8G8_s8ArD0D1ogoY.ttf'
    },
    {
      text: 'Mulish',
      value: 'Mulish',
      url: 'https://fonts.gstatic.com/s/mulish/v3/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNRwaClGrw-PTY.ttf'
    },
    {
      text: 'Arapey',
      value: 'Arapey',
      url: 'https://fonts.gstatic.com/s/arapey/v9/-W__XJn-UDDA2RC6Z9AcZkIzeg.ttf'
    },
    {
      text: 'Nunito',
      value: 'Nunito',
      url: 'https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKof4MuyAbsrVcA.ttf'
    },
    {
      text: 'Asap Condensed',
      value: 'Asap Condensed',
      url: 'https://fonts.gstatic.com/s/asapcondensed/v8/pxidypY1o9NHyXh3WvSbGSggdNeLYk1Mq3ap.ttf'
    },
    {
      text: 'Assistant',
      value: 'Assistant',
      url: 'https://fonts.gstatic.com/s/assistant/v7/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf'
    },
    {
      text: 'Open Sans',
      value: 'Open Sans',
      url: 'https://fonts.gstatic.com/s/opensans/v21/mem8YaGs126MiZpBA-U1UpcaXcl0Aw.ttf'
    },
    {
      text: 'Barlow',
      value: 'Barlow',
      url: 'https://fonts.gstatic.com/s/barlow/v5/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf'
    },
    {
      text: 'Oswald',
      value: 'Oswald',
      url: 'https://fonts.gstatic.com/s/oswald/v38/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgUFoZAaRliE.ttf'
    },
    {
      text: 'Bitter',
      value: 'Bitter',
      url: 'https://fonts.gstatic.com/s/bitter/v19/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCL_EXFh2reU.ttf'
    },
    {
      text: 'Poppins',
      value: 'Poppins',
      url: 'https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf'
    },
    {
      text: 'Brawler',
      value: 'Brawler',
      url: 'https://fonts.gstatic.com/s/brawler/v11/xn7gYHE3xXewAscGsgC7S9XdZN8.ttf'
    },
    {
      text: 'Roboto',
      value: 'Roboto',
      url: 'https://fonts.gstatic.com/s/roboto/v27/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf'
    },
    {
      text: 'Caladea',
      value: 'Caladea',
      url: 'https://fonts.gstatic.com/s/caladea/v2/kJEzBugZ7AAjhybUjR93-9IztOc.ttf'
    },
    {
      text: 'ROKKITT',
      value: 'ROKKITT',
      url: 'https://fonts.gstatic.com/s/rokkitt/v20/qFdb35qfgYFjGy5hukqqhw5XeRgdi1ryd5DLE76HvN6n.ttf'
    },
    {
      text: 'Palette Mosaic',
      value: 'Palette Mosaic',
      url: 'https://fonts.gstatic.com/s/palettemosaic/v1/AMOIz4aBvWuBFe3TohdW6YZ9MFiy4dxL4jSr.ttf'
    },

  ],

  // Streams
  ZoomMeeting: 'ZoomMeeting',
  VimeoLiveStream: 'VimeoLiveStream',
  VimeoChatStream: 'VimeoChatStream',
  LiveChat: 'LiveChat',
  FacebookLiveStream: 'FacebookLiveStream',
  YoutubeLiveStream: 'YoutubeLiveStream',
  JitsiLiveStream: 'JitsiLiveStream',
  VimeoStreams: ['VimeoLiveStream', 'VimeoChatStream'],
  WhereByMeeting:"WhereByMeeting",
  DailyCo:"DailyCo",
  LiveWebinar:"LiveWebinar",
  MediaStream: "MediaStream",
  iFrame: 'iFrame',
  streams: {
    LiveChat: {
      stream_id: 4,
      title: '',
      type: 'LiveChat',
      active: false,
      logo_name: 'live-chat.png',
    },
    YoutubeLiveStream: {
      stream_id: 6,
      title: '',
      type: 'YoutubeLiveStream',
      content: '',
      active: false,
      force: false,
      logo_name: 'youtube.png',
    },
    // ZoomMeeting: {
    //   stream_id: 2,
    //   title: '',
    //   type: 'ZoomMeeting',
    //   meeting_number: '',
    //   meeting_password: '',
    //   active: false,
    //   force: false,
    //   logo_name: 'zoom-logo.png',
    // },
    FacebookLiveStream: {
      stream_id: 5,
      title: '',
      type: 'FacebookLiveStream',
      content: '',
      active: false,
      force: false,
      logo_name: 'facebook-logo.png',
    },
    // VimeoChatStream: {
    //   stream_id: 3,
    //   title: '',
    //   type: 'VimeoChatStream',
    //   vimeo_live_id: '',
    //   active: false,
    //   force: false,
    //   logo_name:'./assets/zoom-logo.png'
    // },
    VimeoLiveStream: {
      stream_id: 1,
      title: '',
      type: 'VimeoLiveStream',
      meeting_link: '',
      active: false,
      force: false,
      logo_name: 'vimeo-logo.png',
    },
    // JitsiLiveStream: {
    //   stream_id: 7,
    //   title: '',
    //   type: 'JitsiLiveStream',
    //   meeting_url: '',
    //   active: false,
    //   force: false,
    //   logo_name: 'jitsi-logo.png',
    // },
    WhereByMeeting: {
      stream_id: 8,
      title: '',
      type: 'WhereByMeeting',
      meeting_url: '',
      active: false,
      force: false,
      logo_name: 'whereby.png',
    },
    LiveWebinar: {
      stream_id: 9,
      title: 'Live Webinar',
      type: 'LiveWebinar',
      meeting_url: '',
      attendee_url: '',
      active: false,
      force: false,
      logo_name: 'live-webinar.png',
    },
    MediaStream: {
      stream_id: 10,
      title: '',
      type: 'MediaStream',
      selected_media_id: null,
      streaming_url: '',
      subtitles: [],
      active: false,
      force: false,
      logo_name: 'live-webinar.png',
    },
    DailyCo: {
      stream_id: 11,
      title: '',
      type: 'DailyCo',
      meeting_url: '',
      active: false,
      force: false,
      logo_name: 'dailyco.png',
    },
    iFrame: {
      stream_id: 12,
      title: '',
      type: 'iFrame',
      source_code: '',
      active: false,
      force: false,
      logo_name: 'iframe.png',
    },
  },
  streams_properties: {
    1: {
      logo_name: 'vimeo-logo.png',
      name: 'Vimeo Live streaming',
    },
    2: {
      logo_name: 'zoom-logo.png',
      name: 'Zoom meeting',
    },
    3: {
      logo_name: 'vimeo-logo.png',
      name: 'Vimeo Live chat',
    },
    4: {
      logo_name: 'live-chat.png',
      name: 'Live chat',
    },
    5: {
      logo_name: 'facebook-logo.png',
      name: 'Facebook live streaming',
    },
    6: {
      logo_name: 'youtube.png',
      name: 'Youtube live streaming',
    },
    7: {
      logo_name: 'jitsi-logo.png',
      name: 'Jitsi live streaming',
    },
    8: {
      logo_name: 'whereby.png',
      name: 'Whereby Meeting',
    },
    9: {
      logo_name: 'live-webinar.png',
      name: 'Live webinar',
    },
    10: {
      logo_name: 'media-stream.png',
      name: 'Media Stream',
    },
    11: {
      logo_name: 'dailyco.png',
      name: 'Daily.co',
    },
    12: {
      logo_name: 'iframe.png',
      name: 'iframe',
    },
  },

  SCREENING_SRC: {
    INTERNAL: 10,
    EXTERNAL: 20,
  },

  FILM_STREAMING_SOURCES: {
    0: 'Encrypted Source',
    1: 'Unencrypted Source',
  },

  MONETIZATION: {
    PRICING_TYPE: {
      SINGLE_PURCHASE: 10 /* Type for purchasing single screening */,
      GROUP_PURCHASE: 20 /* Type for purchasing group of screenings */,
      VOD_PURCHASE: 30 /* Type for purchasing VOD */,
      PHYSICAL_PURCHASE: 40
    },
    CURRENCIES: [
      {
        name: 'USD - US Dollar',
        value: 'USD',
        symbol: '$',
      },
      {
        name: 'DKK - Danish Krone',
        value: 'DKK',
        symbol: 'Kr',
      },
      {
        name: 'EUR - Euro',
        value: 'EUR',
        symbol: '€',
      },
      {
        name: 'GBP - British Pound',
        value: 'GBP',
        symbol: '£',
      },
      {
        name: 'ILS - Israeli New Shekel',
        value: 'ILS',
        symbol: '₪',
      },
      {
        name: 'RON - Romanian Leu',
        value: 'RON',
        symbol: 'Lei',
      },
      {
        name: 'CHF - Swiss Franc',
        value: 'CHF',
        symbol: 'Fr.'
      }
    ],
    CALCULATE_REVENUE_AFTER_HOURS: 48,
    GROUP_PURCHASE: {
      NUMBER_OF_SALES: 500 /* Number of sales represents how many user can purchase this ticket */,
    },
    PURCHASE_TYPE: {
      10: i18n.t('screener.purchase_type.single'),
      20: i18n.t('screener.purchase_type.pass'),
      30: i18n.t('screener.purchase_type.vod'),
      40: i18n.t('screener.purchase_type.venue')
    },
    PURCHASE_TYPES_AS_FILTER: [
      {
        text: i18n.t('screener.purchase_type.all'),
        value: null,
        icon: '$vuetify.icons.rms_image',
      },
      {
        text: i18n.t('screener.purchase_type.single'),
        value: 10,
        icon: '$vuetify.icons.rms_rights',
      },
      {
        text: i18n.t('screener.purchase_type.pass'),
        value: 20,
        icon: '$vuetify.icons.rms_rights',
      },
      {
        text: i18n.t('screener.purchase_type.vod'),
        value: 30,
        icon: '$vuetify.icons.rms_image',
      },
      {
        text: i18n.t('screener.purchase_type.venue'),
        value: 40,
        icon: '$vuetify.icons.rms_video',
      },
    ],
    PAYOUT: {
      CLIENT_PAYOUT: 10,
      REFUND_COST: 20,
      DISPUTE_FROM_CLIENT: 30,
      ADJUSTMENT: 40
    },
    PAYOUT_TYPE: {
      10: i18n.t('screener.payout_type.client_payout'),
      20: i18n.t('screener.payout_type.refund_cost'),
      30: i18n.t('screener.payout_type.dispute_from_client'),
      40: i18n.t('screener.payout_type.adjustment'),
    },
    PAYOUT_STATUS_NAMES: {
      REQUESTED: 10,
      IN_PROCESS: 20,
      REJECTED: 30,
      COMPLETED: 40
    },
    PAYOUT_STATUS:{
      10: i18n.t('screener.payout_status.requested'),
      20: i18n.t('screener.payout_status.in_process'),
      30: i18n.t('screener.payout_status.rejected'),
      40: i18n.t('screener.payout_status.completed'),
    }
  },
  PAYMENT_GATEWAYS:{
    STRIPE:{
      name: i18n.t('screener.payment_gateway.stripe.title'),
      value: "stripe",
      statement_descriptor:"FILM RENT*"
    },
    PAYPAL:{
      name: i18n.t('screener.payment_gateway.paypal.title'),
      value: "paypal"
    },
    ADMIN_PAY:{
      name: i18n.t('screener.payment_gateway.admin_pay.title'),
      value: "admin_pay"
    },
    MESHULAM:{
      name: i18n.t('screener.payment_gateway.meshulam.title'),
      value: "meshulam"
    },
  },
  MAGIC_LINK_WARNINGS: {
    DELETE: [i18n.t ('screener.save.magic.link.mark.delete.dialog.content')],
    GENERATE: [
      i18n.t ('screener.save.magic.link.generate.warning.line1'),
      i18n.t ('screener.save.magic.link.generate.warning.line2'),
      i18n.t ('screener.save.magic.link.generate.warning.line3'),
      i18n.t ('screener.save.magic.link.generate.warning.line4'),
      i18n.t ('screener.save.magic.link.generate.warning.line5'),
    ],
    EXPIRE: [i18n.t ('screener.save.magic.link.mark.expire.dialog.content')],
    PAUSE: [i18n.t ('screener.save.magic.link.mark.paused.dialog.content')],
    GENERATE_NEW: [
      i18n.t ('screener.save.magic.link.mark.generate_new.dialog.content'),
    ],
  },

  UPLOADING_LINK_WARNINGS: {
    DELETE: [i18n.t ('film.save.upload.link.mark.delete.dialog.content')],
    GENERATE: [
      i18n.t ('film.save.upload.link.generate.warning.line1'),
      i18n.t ('film.save.upload.link.generate.warning.line2'),
      i18n.t ('film.save.upload.link.generate.warning.line3'),
    ],
    GENERATE_NEW: [
      i18n.t ('film.save.upload.link.mark.generate_new.dialog.content'),
    ],
  },

  PREVIEW_LINK_WARNING: {
    GENERATE: [
      i18n.t ('screener.save.preview.link.generate.warning.line1'),
      i18n.t ('screener.save.preview.link.generate.warning.line2'),
      i18n.t ('screener.save.preview.link.generate.warning.line3'),
      i18n.t ('screener.save.preview.link.generate.warning.line4'),
    ],
  },
  ACCESS_LINK: {
    STATUS: {
      ACTIVE: 10,
      PAUSED: 20,
      EXPIRED: 30,
    },
  },
  ACCESS_LINK_STATUS_STR: {
    10: 'Active',
    20: 'Paused',
    30: 'Expired',
  },
  gdDevKey: process.env.VUE_APP_GD_DEVELOPER_KEY,
  gdClientId: process.env.VUE_APP_GD_CLIENT_ID,

  COUPON_TYPES: [
    {
      text: i18n.t ('coupon_code.type.all_single_screening'),
      value: 10,
    },
    {
      text: i18n.t ('coupon_code.type.following_screenings'),
      value: 20,
    },
    {
      text: i18n.t ('coupon_code.type.expect_screenings'),
      value: 30,
    },
    {
      text: i18n.t ('coupon_code.type.all_passes'),
      value: 40,
    },
    {
      text: i18n.t ('coupon_code.type.following_passes'),
      value: 50,
    },
    {
      text: i18n.t ('coupon_code.type.expect_passes'),
      value: 60,
    },
    {
      text: i18n.t ('coupon_code.type.all_screening_and_passes'),
      value: 70,
    },
    {
      text: i18n.t ('coupon_code.type.all_vod_events'),
      value: 80,
    },
    {
      text: i18n.t ('coupon_code.type.following_vod_events'),
      value: 90,
    },
    {
      text: i18n.t ('coupon_code.type.expect_vod_events'),
      value: 100,
    },
    {
      text: i18n.t ('coupon_code.type.all_physical_tickets'),
      value: 110,
    },
    {
      text: i18n.t ('coupon_code.type.following_physical_tickets'),
      value: 120,
    },
    {
      text: i18n.t ('coupon_code.type.except_physical_tickets'),
      value: 130,
    },
  ],

  COUPON_TYPES_STR: {
    10: i18n.t ('coupon_code.type.all_single_screening'),
    20: i18n.t ('coupon_code.type.following_screenings'),
    30: i18n.t ('coupon_code.type.expect_screenings'),
    40: i18n.t ('coupon_code.type.all_passes'),
    50: i18n.t ('coupon_code.type.following_passes'),
    60: i18n.t ('coupon_code.type.expect_passes'),
    70: i18n.t ('coupon_code.type.all_screening_and_passes'),
    80: i18n.t ('coupon_code.type.all_vod_events'),
    90: i18n.t ('coupon_code.type.following_vod_events'),
    100: i18n.t ('coupon_code.type.expect_vod_events'),
    110: i18n.t ('coupon_code.type.all_physical_tickets'),
    120: i18n.t ('coupon_code.type.following_physical_tickets'),
    130: i18n.t ('coupon_code.type.except_physical_tickets'),
  },
  COUPON_TYPES_VALUE: {
    ALL_SINGLE_SCREENING: 10,
    FOLLOWING_SCREENING: 20,
    EXPECT_THOSE_SCREENINGS: 30,
    ALL_PASSES: 40,
    FOLLOWING_PASSES: 50,
    EXPECT_THOSE_PASSES: 60,
    ALL_EVENTS_AND_PASSES:70,
    ALL_VOD_EVENTS:80,
    FOLLOWING_VOD_EVENTS:90,
    EXPECT_THOSE_VOD_EVENTS:100,
    ALL_PHYSICAL_EVENTS: 110,
    FOLLOWING_PHYSICAL_EVENTS: 120,
    EXCEPT_FOLLOWING_PHYSICAL_EVENTS: 130,
  },
  COUPON_STATUS_STR: {
    10: 'Active',
    20: 'Paused',
    30: 'Expired',
  },

  COUPON_STATUS: [
    {
      text:'All',
      value:null,
    },
    {
      text: 'Active',
      value: 10
    },
    {
      text: 'Expired',
      value: 30
    },
    {
      text: 'Inactive',
      value: 40
    }
  ],

  SCREENING_TYPE_STR: [
    {
      text: i18n.t ('screener.save.screening_type.single_film_screening'),
      value: 10,
    },
    {
      text: i18n.t ('screener.save.screening_type.multi_films_screening'),
      value: 20,
    },
  ],

  SCREENING_TYPE: {
    SINGLE_FILM_SCREENING: 10,
    MULTI_FILM_SCREENING: 20,
  },

  COMPANY_CREATOR_ROLE: [
    {
      text: i18n.t ('company_creator.role_1'),
      value: 'film_festival',
    },
    {
      text: i18n.t ('company_creator.role_2'),
      value: 'film_organization',
    },
    {
      text: i18n.t ('company_creator.role_3'),
      value: 'education',
    },
    {
      text: i18n.t ('company_creator.role_4'),
      value: 'cultural_institution',
    },
    {
      text: i18n.t ('company_creator.role_5'),
      value: 'production_company',
    },
    {
      text: i18n.t ('company_creator.role_6'),
      value: 'distribution_company',
    },
    {
      text: i18n.t ('company_creator.role_7'),
      value: 'independent_filmmaker',
    },
    // {
    //   text: i18n.t ('company_creator.role_8'),
    //   value: 'other',
    // },
  ],
  MOVIES_EVERYWHERE_TERMS_PAGE_LINK: 'https://movieseverywhere.net/terms-and-privacy/',

  SCREENING_PLAN_TYPE: {
    FREE: 10,
    PREMIUM: 20,
    ENTERPRISE: 30,
  },
  SCREENING_PLAN_TYPE_STR: {
    10: i18n.t ('free.title'),
    20: i18n.t ('premium.title'),
    30: i18n.t ('enterprise.title'),
  },

  PREMIUM_SCREENING_MIN_SEATS: 10,
  PREMIUM_SCREENING_MAX_SEATS: 1000,
  PREMIUM_SCREENING_BASE_CHARGEABLE_AMOUNT: 50, // 50 Euro
  PREMIUM_SCREENING_REDUCED_BASE_CHARGEABLE_AMOUNT: 22, // 22 Euro
  PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL: '€', // 50 Euro
  PREMIUM_SCREENING_DEFAULT_SLOT: 'participant_slot_4_50',
  PREMIUM_SCREENING_SEAT_UPDATE_MODE: {
    UPGRADE: 'upgrade',
    DOWNGRADE: 'downgrade',
  },
  PREMIUM_SCREENING_PRICING_TYPE:{
    NORMAL:10,
    REDUCED:20
  },
  PREMIUM_SCREENING_PRICING_TYPE_STR:{
    10:"Normal",
    20:"Reduced"
  },
  PREMIUM_SCREENING_PARTICIPANT_SLOTS: {
    10:[
      {
        id: 'participant_slot_1_3',
        label: '€0',
        value: 10,
        min_value: 1,
        max_value: 10,
        consolidated_value: 10, // total seats up to this slot
        amount: 0,
        consolidated_amount: 0, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: false,
        should_charge: false,
        description: 'Free',
        range: '1-10',
        charge_on: '-',
      },
      {
        id: 'participant_slot_4_50',
        label: '€50',
        value: 50,
        min_value: 11,
        max_value: 50,
        consolidated_value: 50, // total seats up to this slot
        amount: 50,
        consolidated_amount: 50, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: true,
        description: 'Participants in between this range costs €50',
        range: '4-50',
        charge_on: 'Instantly',
      },
      {
        id: 'participant_slot_51_200',
        label: '€90',
        value: 150,
        min_value: 51,
        max_value: 200,
        consolidated_value: 200, // total seats up to this slot
        amount: 40,
        consolidated_amount: 90, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €90',
        range: '51-200',
        charge_on: '51st participant',
      },
      {
        id: 'participant_slot_201_400',
        label: '€105',
        value: 200,
        min_value: 201,
        max_value: 400,
        consolidated_value: 400, // total seats up to this slot
        amount: 15,
        consolidated_amount: 105, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €105',
        range: '201-400',
        charge_on: '201st participant',
      },
      {
        id: 'participant_slot_401_600',
        label: '€120',
        value: 200,
        min_value: 401,
        max_value: 600,
        consolidated_value: 600, // total seats up to this slot
        amount: 15,
        consolidated_amount: 120, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €120',
        range: '401-600',
        charge_on: '401st participant',
      },
      {
        id: 'participant_slot_601_800',
        label: '€135',
        value: 200,
        min_value: 601,
        max_value: 800,
        consolidated_value: 800, // total seats up to this slot
        amount: 15,
        consolidated_amount: 135, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €135',
        range: '601-800',
        charge_on: '601st participant',
      },
      {
        id: 'participant_slot_801_1000',
        label: '€150',
        value: 200,
        min_value: 801,
        max_value: 1000,
        consolidated_value: 1000, // total seats up to this slot
        amount: 15,
        consolidated_amount: 150, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €150',
        range: '801-1000',
        charge_on: '801st participant',
      },
    ],
    20:[
      {
        id: 'participant_slot_1_3',
        label: '€0',
        value: 10,
        min_value: 1,
        max_value: 10,
        consolidated_value: 10, // total seats up to this slot
        amount: 0,
        consolidated_amount: 0, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: false,
        should_charge: false,
        description: 'Free',
        range: '1-10',
        charge_on: '-',
      },
      {
        id: 'participant_slot_4_50',
        label: '€22',
        value: 50,
        min_value: 11,
        max_value: 50,
        consolidated_value: 50, // total seats up to this slot
        amount: 22,
        consolidated_amount: 22, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: true,
        description: 'Participants in between this range costs €22',
        range: '4-50',
        charge_on: 'Instantly',
      },
      {
        id: 'participant_slot_51_200',
        label: '€39',
        value: 150,
        min_value: 51,
        max_value: 200,
        consolidated_value: 200, // total seats up to this slot
        amount: 17,
        consolidated_amount: 39, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €39',
        range: '51-200',
        charge_on: '51st participant',
      },
      {
        id: 'participant_slot_201_400',
        label: '€45',
        value: 200,
        min_value: 201,
        max_value: 400,
        consolidated_value: 400, // total seats up to this slot
        amount: 6,
        consolidated_amount: 45, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €45',
        range: '201-400',
        charge_on: '201st participant',
      },
      {
        id: 'participant_slot_401_600',
        label: '€52',
        value: 200,
        min_value: 401,
        max_value: 600,
        consolidated_value: 600, // total seats up to this slot
        amount: 7,
        consolidated_amount: 52, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €52',
        range: '401-600',
        charge_on: '401st participant',
      },
      {
        id: 'participant_slot_601_800',
        label: '€60',
        value: 200,
        min_value: 601,
        max_value: 800,
        consolidated_value: 800, // total seats up to this slot
        amount: 8,
        consolidated_amount: 60, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €60',
        range: '601-800',
        charge_on: '601st participant',
      },
      {
        id: 'participant_slot_801_1000',
        label: '€69',
        value: 200,
        min_value: 801,
        max_value: 1000,
        consolidated_value: 1000, // total seats up to this slot
        amount: 9,
        consolidated_amount: 69, // total cost up to this slot
        currency: 'EUR',
        currency_symbol: '€',
        active: true,
        should_charge: false,
        description: 'Participants in between this range costs €69',
        range: '801-1000',
        charge_on: '801st participant',
      }
    ]
  },

  SCREENING_ADD_ONS: [
    {
      id: 'content_management_by_team',
      db_key: 'is_content_management_enabled',
      label: '€30',
      amount: 30,
      currency: 'EUR',
      currency_symbol: '€',
      should_charge: true,
      title: 'Content Management',
      description: 'Content management by Communicada team. It includes upload and screening creation',
      charge_on: 'Instantly',
      quantity: 0,
    },
    {
      id: 'support_management_by_team',
      db_key: 'is_support_to_end_user_enabled',
      label: '€30',
      amount: 30,
      currency: 'EUR',
      currency_symbol: '€',
      should_charge: true,
      title: 'Support Management',
      description: 'Support to end-users by Communicada team (English only)',
      charge_on: 'Instantly',
      quantity: 0,
    },
  ],

  MOVIES_EVERYWHERE_COMMISSION_PERCENTAGE: 0,
  ENTERPRISE_PRICING_WARNINGS: {
    ENABLE: [
      i18n.t ('enterprise.pricing.enable.warning.line1'),
      i18n.t ('enterprise.pricing.enable.warning.line2'),
      i18n.t ('enterprise.pricing.enable.warning.line3'),
      i18n.t ('enterprise.pricing.enable.warning.line4'),
      i18n.t ('enterprise.pricing.enable.warning.line5'),
      i18n.t ('enterprise.pricing.enable.warning.line6'),
      i18n.t ('enterprise.pricing.logout.warning')
    ],
    DISABLE: [
      i18n.t ('enterprise.pricing.disable.warning.line1'),
      i18n.t ('enterprise.pricing.disable.warning.line2'),
      i18n.t ('enterprise.pricing.disable.warning.line3'),
      i18n.t ('enterprise.pricing.disable.warning.line4'),
      i18n.t ('enterprise.pricing.disable.warning.line5'),
      i18n.t ('enterprise.pricing.logout.warning')
    ],
  },
  SCREENING_TYPES: [
    {
      text: 'All',
      value: null,
    },
    {
      text: i18n.t ('free.title'),
      value: 10,
    },
    {
      text: i18n.t ('premium.title'),
      value: 20,
    },
    {
      text: i18n.t ('enterprise.title'),
      value: 30,
    },
  ],
  PREMIUM_SCREENING_FAQS: [
    {
      text: i18n.t ('screener.budget_panner.faqs.q_1'),
      value: i18n.t ('screener.budget_panner.faqs.a_1'),
    },
    {
      text: i18n.t ('screener.budget_panner.faqs.q_2'),
      value: i18n.t ('screener.budget_panner.faqs.a_2'),
    },
    {
      text: i18n.t ('screener.budget_panner.faqs.q_3'),
      value: i18n.t ('screener.budget_panner.faqs.a_3'),
    },
    {
      text: i18n.t ('screener.budget_panner.faqs.q_4'),
      value: i18n.t ('screener.budget_panner.faqs.a_4'),
    },
    {
      text: i18n.t ('screener.budget_panner.faqs.q_5'),
      value: i18n.t ('screener.budget_panner.faqs.a_5'),
    },
    {
      text: i18n.t ('screener.budget_panner.faqs.q_6'),
      value: i18n.t ('screener.budget_panner.faqs.a_6'),
    },
  ],
  ADDONS_FAQS: [
    {
      text: i18n.t ('addon.budget_panner.faqs.q_1'),
      value: i18n.t ('addon.budget_panner.faqs.a_1'),
    },
  ],
  IMPORT_REGISTRANTS_FAQS:[
    {
      text: i18n.t ('screener.import_registrants.faqs.q_0'),
      value: i18n.t ('screener.import_registrants.faqs.a_0'),
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_1'),
      value: i18n.t ('screener.import_registrants.faqs.a_1'),
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_2'),
      value: i18n.t ('screener.import_registrants.faqs.a_2'),
      image:'import-field-format.png'
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_3'),
      value: i18n.t ('screener.import_registrants.faqs.a_3'),
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_4'),
      value: i18n.t ('screener.import_registrants.faqs.a_4'),
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_5'),
      value: i18n.t ('screener.import_registrants.faqs.a_5'),
    },
    {
      text: i18n.t ('screener.import_registrants.faqs.q_6'),
      value: i18n.t ('screener.import_registrants.faqs.a_6'),
    },
  ],

  /**
 * STREAMING NETWORK ERROR CODES
 */

    EVENT_NOT_STARTED: 425,
    EVENT_FINISHED: 555,
    TOKEN_MISSING: 551,
    TOKEN_MISMATCH: 552,
    UNENROLLED: 553,
    GEO_BLOCKED: 557,
    SESSION_DELETED: 556,
    SERVER_ERROR: 500,
  EVENT_TYPE: {
    STANDARD_EVENTS: 'StandardEvents',
    VOD_EVENTS: 'VodEvents',
    PHYSICAL_EVENTS: 'PhisicalEvents'
  },
  VOD_EVENT_DEFAULT_AVAILABILITY: 72, //(3 Days)
  IGNORED_TIMEZONES: ["CET","America/Lima"],
  SCREENER_TYPE: {
    VIRTUAL: 10,
    PHYSICAL: 20,
    VIRTUAL_AND_PHYSICAL: 50
  },
  SCREENER_TYPES:[
    {
      text:i18n.t('defines.screener_type_str.virtual'),
      value:10,
    },
    {
      text:i18n.t('defines.screener_type_str.physical'),
      value:20,
    },
    {
      text:i18n.t('defines.screener_type_str.virtual_and_physical'),
      value:50,
    }
  ],
  SCREENER_TYPE_STR: {
    10: i18n.t('defines.screener_type_str.virtual'),
    20: i18n.t('defines.screener_type_str.physical'),
    50: i18n.t('defines.screener_type_str.virtual_and_physical'),
  },
  SEAT_LABELLING_TYPE: {
    ALPHABETS: 10,
    NUMERIC: 20,
  },
  SEAT_LABELLING_TYPES_ARRAY: [
    {
      "text":i18n.t('defines.seat_labelling_type_str.alphabets'),
      "value":10
    },
    {
      "text":i18n.t('defines.seat_labelling_type_str.numeric'),
      "value":20
    }
  ],
  SEATS_STATUS:{
    AVAILABLE:10,
    LOCKED:20,
    BOOKED:30,
  },
  BOOKING_STATUS_COLORS:{
    10:'error',
    20:'error',
    40:'success'
  },
  BOOKING_STATUS_STR:{
    10:'Canceled',
    20:'Locked',
    30:'Payment initiated',
    35:'Payment failed',
    40:'Booked'
  },
  BOOKING_STATUS_INT: {
    'CANCELLED': 10,
    'LOCKED': 20,
    'PAYMENT_INITIATED':30,
    'PAYMENT_FAILED': 35,
    'BOOKED': 40,
    'ALL': null
  },
  SEATS_CATEGORIES:{
    10:{
      label:i18n.t('screener.seats.category.regular.title'),
      value:10,
      colorClass:"cls-seat-category-regular",
      color: 'white'
    },
    20:{
      label:i18n.t('screener.seats.category.cheaper.title'),
      value:20,
      colorClass:"cls-seat-category-cheaper",
      color: 'yellow lighten-4'
    },
    30:{
      label:i18n.t('screener.seats.category.premium.title'),
      value:30,
      colorClass:"cls-seat-category-premium",
      color: 'blue lighten-3'
    },
    40:{
      label:i18n.t('screener.seats.category.disabled.title'),
      value:40,
      colorClass:"cls-seat-category-disabled",
      color: 'deep-purple lighten-4'
    },
  },
  SEAT_CATEGORIES: [
    {
      text:  i18n.t('screener.seats.category.regular.title'),
      value: 10
    },
    {
      text:  i18n.t('screener.seats.category.child.title'),
      value: 20
    },
    {
      text:  i18n.t('screener.seats.category.student.title'),
      value: 30
    },
    {
      text:  i18n.t('screener.seats.category.senior.title'),
      value: 40
    },
    {
      text:  i18n.t('screener.seats.category.disabled.title'),
      value: 50
    },
  ],
  SEAT_CATEGORIES_VALUE: {
    'REGULAR':   10,
    'CHEAPER' :  20,
    'PREMIUM' :  30,
    'DISABLED' : 40
  },
  SEATS_TICKET_TYPES : [
    {
      label: i18n.t('screener.seats.ticket.type.none.title'),
      value: 0
    },
    {
      label:  i18n.t('screener.seats.ticket.type.child.title'),
      value: 10
    },
    {
      label:  i18n.t('screener.seats.ticket.type.student.title'),
      value: 20
    },
    {
      label:  i18n.t('screener.seats.ticket.type.senior.title'),
      value: 30
    }
  ],

  SEAT_TICKET_TYPES_VALUE: {
    'CHILD':   10,
    'STUDENT' :  20,
    'SENIOR' :  30,
  },

  SEAT_TICKET_TYPES_LABEL: {
       10 : 'CHILD',
       20 : 'STUDENT',
       30 : 'SENIOR',
  },

  MAXIMUM_SEAT_SELECTION_AT_ONCE:6,

  COUNTRY_LANGUAGES:[
    {"code":"ab","name":"Abkhaz","nativeName":"аҧсуа"},
    {"code":"aa","name":"Afar","nativeName":"Afaraf"},
    {"code":"af","name":"Afrikaans","nativeName":"Afrikaans"},
    {"code":"ak","name":"Akan","nativeName":"Akan"},
    {"code":"sq","name":"Albanian","nativeName":"Shqip"},
    {"code":"am","name":"Amharic","nativeName":"አማርኛ"},
    {"code":"ar","name":"Arabic","nativeName":"العربية"},
    {"code":"an","name":"Aragonese","nativeName":"Aragonés"},
    {"code":"hy","name":"Armenian","nativeName":"Հայերեն"},
    {"code":"as","name":"Assamese","nativeName":"অসমীয়া"},
    {"code":"av","name":"Avaric","nativeName":"авар мацӀ, магӀарул мацӀ"},
    {"code":"ae","name":"Avestan","nativeName":"avesta"},
    {"code":"ay","name":"Aymara","nativeName":"aymar aru"},
    {"code":"az","name":"Azerbaijani","nativeName":"azərbaycan dili"},
    {"code":"bm","name":"Bambara","nativeName":"bamanankan"},
    {"code":"ba","name":"Bashkir","nativeName":"башҡорт теле"},
    {"code":"eu","name":"Basque","nativeName":"euskara, euskera"},
    {"code":"be","name":"Belarusian","nativeName":"Беларуская"},
    {"code":"bn","name":"Bengali","nativeName":"বাংলা"},
    {"code":"bh","name":"Bihari","nativeName":"भोजपुरी"},
    {"code":"bi","name":"Bislama","nativeName":"Bislama"},
    {"code":"bs","name":"Bosnian","nativeName":"bosanski jezik"},
    {"code":"br","name":"Breton","nativeName":"brezhoneg"},
    {"code":"bg","name":"Bulgarian","nativeName":"български език"},
    {"code":"my","name":"Burmese","nativeName":"ဗမာစာ"},
    {"code":"ca","name":"Catalan; Valencian","nativeName":"Català"},
    {"code":"ch","name":"Chamorro","nativeName":"Chamoru"},
    {"code":"ce","name":"Chechen","nativeName":"нохчийн мотт"},
    {"code":"ny","name":"Chichewa; Chewa; Nyanja","nativeName":"chiCheŵa, chinyanja"},
    {"code":"zh","name":"Chinese","nativeName":"中文 (Zhōngwén), 汉语, 漢語"},
    {"code":"cv","name":"Chuvash","nativeName":"чӑваш чӗлхи"},
    {"code":"kw","name":"Cornish","nativeName":"Kernewek"},
    {"code":"co","name":"Corsican","nativeName":"corsu, lingua corsa"},
    {"code":"cr","name":"Cree","nativeName":"ᓀᐦᐃᔭᐍᐏᐣ"},
    {"code":"hr","name":"Croatian","nativeName":"hrvatski"},
    {"code":"cs","name":"Czech","nativeName":"česky, čeština"},
    {"code":"da","name":"Danish","nativeName":"dansk"},
    {"code":"dv","name":"Divehi; Dhivehi; Maldivian;","nativeName":"ދިވެހި"},
    {"code":"nl","name":"Dutch","nativeName":"Nederlands, Vlaams"},
    {"code":"en","name":"English","nativeName":"English"},
    {"code":"eo","name":"Esperanto","nativeName":"Esperanto"},
    {"code":"et","name":"Estonian","nativeName":"eesti, eesti keel"},
    {"code":"ee","name":"Ewe","nativeName":"Eʋegbe"},
    {"code":"fo","name":"Faroese","nativeName":"føroyskt"},
    {"code":"fj","name":"Fijian","nativeName":"vosa Vakaviti"},
    {"code":"fi","name":"Finnish","nativeName":"suomi, suomen kieli"},
    {"code":"fr","name":"French","nativeName":"français, langue française"},
    {"code":"ff","name":"Fula; Fulah; Pulaar; Pular","nativeName":"Fulfulde, Pulaar, Pular"},
    {"code":"gl","name":"Galician","nativeName":"Galego"},
    {"code":"ka","name":"Georgian","nativeName":"ქართული"},
    {"code":"de","name":"German","nativeName":"Deutsch"},
    {"code":"el","name":"Greek, Modern","nativeName":"Ελληνικά"},
    {"code":"gn","name":"Guaraní","nativeName":"Avañeẽ"},
    {"code":"gu","name":"Gujarati","nativeName":"ગુજરાતી"},
    {"code":"ht","name":"Haitian; Haitian Creole","nativeName":"Kreyòl ayisyen"},
    {"code":"ha","name":"Hausa","nativeName":"Hausa, هَوُسَ"},
    {"code":"he","name":"Hebrew (modern)","nativeName":"עברית"},
    {"code":"hz","name":"Herero","nativeName":"Otjiherero"},
    {"code":"hi","name":"Hindi","nativeName":"हिन्दी, हिंदी"},
    {"code":"ho","name":"Hiri Motu","nativeName":"Hiri Motu"},
    {"code":"hu","name":"Hungarian","nativeName":"Magyar"},
    {"code":"ia","name":"Interlingua","nativeName":"Interlingua"},
    {"code":"id","name":"Indonesian","nativeName":"Bahasa Indonesia"},
    {"code":"ie","name":"Interlingue","nativeName":"Originally called Occidental; then Interlingue after WWII"},
    {"code":"ga","name":"Irish","nativeName":"Gaeilge"},
    {"code":"ig","name":"Igbo","nativeName":"Asụsụ Igbo"},
    {"code":"ik","name":"Inupiaq","nativeName":"Iñupiaq, Iñupiatun"},
    {"code":"io","name":"Ido","nativeName":"Ido"},
    {"code":"is","name":"Icelandic","nativeName":"Íslenska"},
    {"code":"it","name":"Italian","nativeName":"Italiano"},
    {"code":"iu","name":"Inuktitut","nativeName":"ᐃᓄᒃᑎᑐᑦ"},
    {"code":"ja","name":"Japanese","nativeName":"日本語 (にほんご／にっぽんご)"},
    {"code":"jv","name":"Javanese","nativeName":"basa Jawa"},
    {"code":"kl","name":"Kalaallisut, Greenlandic","nativeName":"kalaallisut, kalaallit oqaasii"},
    {"code":"kn","name":"Kannada","nativeName":"ಕನ್ನಡ"},
    {"code":"kr","name":"Kanuri","nativeName":"Kanuri"},
    {"code":"ks","name":"Kashmiri","nativeName":"कश्मीरी, كشميري‎"},
    {"code":"kk","name":"Kazakh","nativeName":"Қазақ тілі"},
    {"code":"km","name":"Khmer","nativeName":"ភាសាខ្មែរ"},
    {"code":"ki","name":"Kikuyu, Gikuyu","nativeName":"Gĩkũyũ"},
    {"code":"rw","name":"Kinyarwanda","nativeName":"Ikinyarwanda"},
    {"code":"ky","name":"Kirghiz, Kyrgyz","nativeName":"кыргыз тили"},
    {"code":"kv","name":"Komi","nativeName":"коми кыв"},
    {"code":"kg","name":"Kongo","nativeName":"KiKongo"},
    {"code":"ko","name":"Korean","nativeName":"한국어 (韓國語), 조선말 (朝鮮語)"},
    {"code":"ku","name":"Kurdish","nativeName":"Kurdî, كوردی‎"},
    {"code":"kj","name":"Kwanyama, Kuanyama","nativeName":"Kuanyama"},
    {"code":"la","name":"Latin","nativeName":"latine, lingua latina"},
    {"code":"lb","name":"Luxembourgish, Letzeburgesch","nativeName":"Lëtzebuergesch"},
    {"code":"lg","name":"Luganda","nativeName":"Luganda"},
    {"code":"li","name":"Limburgish, Limburgan, Limburger","nativeName":"Limburgs"},
    {"code":"ln","name":"Lingala","nativeName":"Lingála"},
    {"code":"lo","name":"Lao","nativeName":"ພາສາລາວ"},
    {"code":"lt","name":"Lithuanian","nativeName":"lietuvių kalba"},
    {"code":"lu","name":"Luba-Katanga","nativeName":""},
    {"code":"lv","name":"Latvian","nativeName":"latviešu valoda"},
    {"code":"gv","name":"Manx","nativeName":"Gaelg, Gailck"},
    {"code":"mk","name":"Macedonian","nativeName":"македонски јазик"},
    {"code":"mg","name":"Malagasy","nativeName":"Malagasy fiteny"},
    {"code":"ms","name":"Malay","nativeName":"bahasa Melayu, بهاس ملايو‎"},
    {"code":"ml","name":"Malayalam","nativeName":"മലയാളം"},
    {"code":"mt","name":"Maltese","nativeName":"Malti"},
    {"code":"mi","name":"Māori","nativeName":"te reo Māori"},
    {"code":"mr","name":"Marathi (Marāṭhī)","nativeName":"मराठी"},
    {"code":"mh","name":"Marshallese","nativeName":"Kajin M̧ajeļ"},
    {"code":"mn","name":"Mongolian","nativeName":"монгол"},
    {"code":"na","name":"Nauru","nativeName":"Ekakairũ Naoero"},
    {"code":"nv","name":"Navajo, Navaho","nativeName":"Diné bizaad, Dinékʼehǰí"},
    {"code":"nb","name":"Norwegian Bokmål","nativeName":"Norsk bokmål"},
    {"code":"nd","name":"North Ndebele","nativeName":"isiNdebele"},
    {"code":"ne","name":"Nepali","nativeName":"नेपाली"},
    {"code":"ng","name":"Ndonga","nativeName":"Owambo"},
    {"code":"nn","name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"},
    {"code":"no","name":"Norwegian","nativeName":"Norsk"},
    {"code":"ii","name":"Nuosu","nativeName":"ꆈꌠ꒿ Nuosuhxop"},
    {"code":"nr","name":"South Ndebele","nativeName":"isiNdebele"},
    {"code":"oc","name":"Occitan","nativeName":"Occitan"},
    {"code":"oj","name":"Ojibwe, Ojibwa","nativeName":"ᐊᓂᔑᓈᐯᒧᐎᓐ"},
    {"code":"cu","name":"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic","nativeName":"ѩзыкъ словѣньскъ"},
    {"code":"om","name":"Oromo","nativeName":"Afaan Oromoo"},
    {"code":"or","name":"Oriya","nativeName":"ଓଡ଼ିଆ"},
    {"code":"os","name":"Ossetian, Ossetic","nativeName":"ирон æвзаг"},
    {"code":"pa","name":"Panjabi, Punjabi","nativeName":"ਪੰਜਾਬੀ, پنجابی‎"},
    {"code":"pi","name":"Pāli","nativeName":"पाऴि"},
    {"code":"fa","name":"Persian","nativeName":"فارسی"},
    {"code":"pl","name":"Polish","nativeName":"polski"},
    {"code":"ps","name":"Pashto, Pushto","nativeName":"پښتو"},
    {"code":"pt","name":"Portuguese","nativeName":"Português"},
    {"code":"qu","name":"Quechua","nativeName":"Runa Simi, Kichwa"},
    {"code":"rm","name":"Romansh","nativeName":"rumantsch grischun"},
    {"code":"rn","name":"Kirundi","nativeName":"kiRundi"},
    {"code":"ro","name":"Romanian, Moldavian, Moldovan","nativeName":"română"},
    {"code":"ru","name":"Russian","nativeName":"русский язык"},
    {"code":"sa","name":"Sanskrit (Saṁskṛta)","nativeName":"संस्कृतम्"},
    {"code":"sc","name":"Sardinian","nativeName":"sardu"},
    {"code":"sd","name":"Sindhi","nativeName":"सिन्धी, سنڌي، سندھی‎"},
    {"code":"se","name":"Northern Sami","nativeName":"Davvisámegiella"},
    {"code":"sm","name":"Samoan","nativeName":"gagana faa Samoa"},
    {"code":"sg","name":"Sango","nativeName":"yângâ tî sängö"},
    {"code":"sr","name":"Serbian","nativeName":"српски језик"},
    {"code":"gd","name":"Scottish Gaelic; Gaelic","nativeName":"Gàidhlig"},
    {"code":"sn","name":"Shona","nativeName":"chiShona"},
    {"code":"si","name":"Sinhala, Sinhalese","nativeName":"සිංහල"},
    {"code":"sk","name":"Slovak","nativeName":"slovenčina"},
    {"code":"sl","name":"Slovene","nativeName":"slovenščina"},
    {"code":"so","name":"Somali","nativeName":"Soomaaliga, af Soomaali"},
    {"code":"st","name":"Southern Sotho","nativeName":"Sesotho"},
    {"code":"es","name":"Spanish; Castilian","nativeName":"español, castellano"},
    {"code":"su","name":"Sundanese","nativeName":"Basa Sunda"},
    {"code":"sw","name":"Swahili","nativeName":"Kiswahili"},
    {"code":"ss","name":"Swati","nativeName":"SiSwati"},
    {"code":"sv","name":"Swedish","nativeName":"svenska"},
    {"code":"ta","name":"Tamil","nativeName":"தமிழ்"},
    {"code":"te","name":"Telugu","nativeName":"తెలుగు"},
    {"code":"tg","name":"Tajik","nativeName":"тоҷикӣ, toğikī, تاجیکی‎"},
    {"code":"th","name":"Thai","nativeName":"ไทย"},
    {"code":"ti","name":"Tigrinya","nativeName":"ትግርኛ"},
    {"code":"bo","name":"Tibetan Standard, Tibetan, Central","nativeName":"བོད་ཡིག"},
    {"code":"tk","name":"Turkmen","nativeName":"Türkmen, Түркмен"},
    {"code":"tl","name":"Tagalog","nativeName":"Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"},
    {"code":"tn","name":"Tswana","nativeName":"Setswana"},
    {"code":"to","name":"Tonga (Tonga Islands)","nativeName":"faka Tonga"},
    {"code":"tr","name":"Turkish","nativeName":"Türkçe"},
    {"code":"ts","name":"Tsonga","nativeName":"Xitsonga"},
    {"code":"tt","name":"Tatar","nativeName":"татарча, tatarça, تاتارچا‎"},
    {"code":"tw","name":"Twi","nativeName":"Twi"},
    {"code":"ty","name":"Tahitian","nativeName":"Reo Tahiti"},
    {"code":"ug","name":"Uighur, Uyghur","nativeName":"Uyƣurqə, ئۇيغۇرچە‎"},
    {"code":"uk","name":"Ukrainian","nativeName":"українська"},
    {"code":"ur","name":"Urdu","nativeName":"اردو"},
    {"code":"uz","name":"Uzbek","nativeName":"zbek, Ўзбек, أۇزبېك‎"},
    {"code":"ve","name":"Venda","nativeName":"Tshivenḓa"},
    {"code":"vi","name":"Vietnamese","nativeName":"Tiếng Việt"},
    {"code":"vo","name":"Volapük","nativeName":"Volapük"},
    {"code":"wa","name":"Walloon","nativeName":"Walon"},
    {"code":"cy","name":"Welsh","nativeName":"Cymraeg"},
    {"code":"wo","name":"Wolof","nativeName":"Wollof"},
    {"code":"fy","name":"Western Frisian","nativeName":"Frysk"},
    {"code":"xh","name":"Xhosa","nativeName":"isiXhosa"},
    {"code":"yi","name":"Yiddish","nativeName":"ייִדיש"},
    {"code":"yo","name":"Yoruba","nativeName":"Yorùbá"},
    {"code":"za","name":"Zhuang, Chuang","nativeName":"Saɯ cueŋƅ, Saw cuengh"}
  ],
  AFFILIATION:{
    DEFAULT_VALIDITY_IN_DAYS:30,
    DEFAULT_REPORTING_INTERVAL:20,
    REPORTING_INTERVALS:[
      {
        label:i18n.t('screener.affiliation.reporting_interval.weekly'),
        value:10
      },
      {
        label:i18n.t('screener.affiliation.reporting_interval.monthly'),
        value:20
      }
    ]
  },
  FILM:{
    INPUT_FIELDS:[
      {
        label:i18n.t('screener.film.title'),
        value:'title',
        disabled: false
      },
      {
        label:i18n.t('screener.film.subtitle'),
        value:'subtitle',
        disabled: false
      },
      {
        label:i18n.t('screener.film.description'),
        value:'description',
        disabled: false
      },
      {
        label:i18n.t('screener.film.director.title'),
        value:'director_name',
        disabled:false
      },
      {
        label:i18n.t('screener.film.producer.title'),
        value:'producer_name',
        disabled:false
      },
      {
        label:i18n.t('rms.field.length.label'),
        value:'length',
        disabled:false
      },
      {
        label:i18n.t('screener.film.trailer_link.title'),
        value:'trailer',
        disabled:false
      },
      {
        label:i18n.t('screener.film.right_holder_email.title'),
        value:'right_holder_email',
        disabled:false
      },
      {
        label:i18n.t('screener.film.right_holder_share.title'),
        value:'right_holder_share',
        disabled:false
      },
      {
        label:i18n.t('screener.film.minimum_guarantee.title'),
        value:'minimum_guarantee',
        disabled:false
      },
      {
        label:i18n.t('screener.film.fees.title'),
        value:'fees',
        disabled:false
      },
      {
        label:i18n.t('screener.film.imdb_url'),
        value:'imdb_ref',
        disabled:false
      },
      {
        label:i18n.t('screener.film.released_year.title'),
        value:'released_year',
        disabled:false
      },
      {
        label:i18n.t('screener.film.sales_agent.title'),
        value:'sales_agent',
        disabled:false
      },
      {
        label:i18n.t('screener.film.scripting.title'),
        value:'script_writer',
        disabled:false
      },
      {
        label:i18n.t('screener.film.cinematography.title'),
        value:'cinematography',
        disabled:false
      },
      {
        label:i18n.t('screener.film.editing.title'),
        value:'editing',
        disabled:false
      },
      {
        label:i18n.t('screener.film.music.title'),
        value:'music',
        disabled:false
      },
      {
        label:i18n.t('screener.film.cast.title'),
        value:'cast',
        disabled:false
      },
      {
        label:i18n.t('screener.film.backing.title'),
        value:'backing',
        disabled:false
      }
    ]
  },
  WHITELABEL_STATUS: {
    NOT_CONFIGURED: 10,
    REQUESTED: 20,
    FAILED: 30,
    ACTIVE: 50
  },
  /**
   * Reference :-
   * https://vcalendar.io/timezones.html
   * https://stackoverflow.com/questions/38399465/how-to-get-list-of-all-timezones-in-javascript
   */
  SUPPORTED_TIMEZONES:[
    'Europe/Andorra',
    'Asia/Dubai',
    'Asia/Kabul',
    'Europe/Tirane',
    'Asia/Yerevan',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
    'Antarctica/Mawson',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Cordoba',
    'America/Argentina/Salta',
    'America/Argentina/Jujuy',
    'America/Argentina/Tucuman',
    'America/Argentina/Catamarca',
    'America/Argentina/La_Rioja',
    'America/Argentina/San_Juan',
    'America/Argentina/Mendoza',
    'America/Argentina/San_Luis',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Ushuaia',
    'Pacific/Pago_Pago',
    'Europe/Vienna',
    'Australia/Lord_Howe',
    'Antarctica/Macquarie',
    'Australia/Hobart',
    'Australia/Currie',
    'Australia/Melbourne',
    'Australia/Sydney',
    'Australia/Broken_Hill',
    'Australia/Brisbane',
    'Australia/Lindeman',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
    'Australia/Eucla',
    'Asia/Baku',
    'America/Barbados',
    'Asia/Dhaka',
    'Europe/Brussels',
    'Europe/Sofia',
    'Atlantic/Bermuda',
    'Asia/Brunei',
    'America/La_Paz',
    'America/Noronha',
    'America/Belem',
    'America/Fortaleza',
    'America/Recife',
    'America/Araguaina',
    'America/Maceio',
    'America/Bahia',
    'America/Sao_Paulo',
    'America/Campo_Grande',
    'America/Cuiaba',
    'America/Santarem',
    'America/Porto_Velho',
    'America/Boa_Vista',
    'America/Manaus',
    'America/Eirunepe',
    'America/Rio_Branco',
    'America/Nassau',
    'Asia/Thimphu',
    'Europe/Minsk',
    'America/Belize',
    'America/St_Johns',
    'America/Halifax',
    'America/Glace_Bay',
    'America/Moncton',
    'America/Goose_Bay',
    'America/Blanc-Sablon',
    'America/Toronto',
    'America/Nipigon',
    'America/Thunder_Bay',
    'America/Iqaluit',
    'America/Pangnirtung',
    'America/Atikokan',
    'America/Winnipeg',
    'America/Rainy_River',
    'America/Resolute',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Swift_Current',
    'America/Edmonton',
    'America/Cambridge_Bay',
    'America/Yellowknife',
    'America/Inuvik',
    'America/Creston',
    'America/Dawson_Creek',
    'America/Fort_Nelson',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Dawson',
    'Indian/Cocos',
    'Europe/Zurich',
    'Africa/Abidjan',
    'Pacific/Rarotonga',
    'America/Santiago',
    'America/Punta_Arenas',
    'Pacific/Easter',
    'Asia/Shanghai',
    'Asia/Urumqi',
    'America/Bogota',
    'America/Costa_Rica',
    'America/Havana',
    'Atlantic/Cape_Verde',
    'America/Curacao',
    'Indian/Christmas',
    'Asia/Nicosia',
    'Asia/Famagusta',
    'Europe/Prague',
    'Europe/Berlin',
    'Europe/Copenhagen',
    'America/Santo_Domingo',
    'Africa/Algiers',
    'America/Guayaquil',
    'Pacific/Galapagos',
    'Europe/Tallinn',
    'Africa/Cairo',
    'Africa/El_Aaiun',
    'Europe/Madrid',
    'Africa/Ceuta',
    'Atlantic/Canary',
    'Europe/Helsinki',
    'Pacific/Fiji',
    'Atlantic/Stanley',
    'Pacific/Chuuk',
    'Pacific/Pohnpei',
    'Pacific/Kosrae',
    'Atlantic/Faroe',
    'Europe/Paris',
    'Europe/London',
    'Asia/Tbilisi',
    'America/Cayenne',
    'Africa/Accra',
    'Europe/Gibraltar',
    'America/Godthab',
    'America/Danmarkshavn',
    'America/Scoresbysund',
    'America/Thule',
    'Europe/Athens',
    'Atlantic/South_Georgia',
    'America/Guatemala',
    'Pacific/Guam',
    'Africa/Bissau',
    'America/Guyana',
    'Asia/Hong_Kong',
    'America/Tegucigalpa',
    'America/Port-au-Prince',
    'Europe/Budapest',
    'Asia/Jakarta',
    'Asia/Pontianak',
    'Asia/Makassar',
    'Asia/Jayapura',
    'Europe/Dublin',
    'Asia/Jerusalem',
    'Asia/Kolkata',
    'Indian/Chagos',
    'Asia/Baghdad',
    'Asia/Tehran',
    'Atlantic/Reykjavik',
    'Europe/Rome',
    'America/Jamaica',
    'Asia/Amman',
    'Asia/Tokyo',
    'Africa/Nairobi',
    'Asia/Bishkek',
    'Pacific/Tarawa',
    'Pacific/Enderbury',
    'Pacific/Kiritimati',
    'Asia/Pyongyang',
    'Asia/Seoul',
    'Asia/Almaty',
    'Asia/Qyzylorda',
    'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
    'Asia/Aqtobe',
    'Asia/Aqtau',
    'Asia/Atyrau',
    'Asia/Oral',
    'Asia/Beirut',
    'Asia/Colombo',
    'Africa/Monrovia',
    'Europe/Vilnius',
    'Europe/Luxembourg',
    'Europe/Riga',
    'Africa/Tripoli',
    'Africa/Casablanca',
    'Europe/Monaco',
    'Europe/Chisinau',
    'Pacific/Majuro',
    'Pacific/Kwajalein',
    'Asia/Yangon',
    'Asia/Ulaanbaatar',
    'Asia/Hovd',
    'Asia/Choibalsan',
    'Asia/Macau',
    'America/Martinique',
    'Europe/Malta',
    'Indian/Mauritius',
    'Indian/Maldives',
    'America/Mexico_City',
    'America/Cancun',
    'America/Merida',
    'America/Monterrey',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Chihuahua',
    'America/Ojinaga',
    'America/Hermosillo',
    'America/Tijuana',
    'America/Bahia_Banderas',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Africa/Maputo',
    'Africa/Windhoek',
    'Pacific/Noumea',
    'Pacific/Norfolk',
    'Africa/Lagos',
    'America/Managua',
    'Europe/Amsterdam',
    'Europe/Oslo',
    'Asia/Kathmandu',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'America/Panama',
    'America/Lima',
    'Pacific/Tahiti',
    'Pacific/Marquesas',
    'Pacific/Gambier',
    'Pacific/Port_Moresby',
    'Pacific/Bougainville',
    'Asia/Manila',
    'Asia/Karachi',
    'Europe/Warsaw',
    'America/Miquelon',
    'Pacific/Pitcairn',
    'America/Puerto_Rico',
    'Asia/Gaza',
    'Asia/Hebron',
    'Europe/Lisbon',
    'Atlantic/Madeira',
    'Atlantic/Azores',
    'Pacific/Palau',
    'America/Asuncion',
    'Asia/Qatar',
    'Indian/Reunion',
    'Europe/Bucharest',
    'Europe/Belgrade',
    'Europe/Kaliningrad',
    'Europe/Moscow',
    'Europe/Simferopol',
    'Europe/Kirov',
    'Europe/Astrakhan',
    'Europe/Volgograd',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Europe/Samara',
    'Asia/Yekaterinburg',
    'Asia/Omsk',
    'Asia/Novosibirsk',
    'Asia/Barnaul',
    'Asia/Tomsk',
    'Asia/Novokuznetsk',
    'Asia/Krasnoyarsk',
    'Asia/Irkutsk',
    'Asia/Chita',
    'Asia/Yakutsk',
    'Asia/Khandyga',
    'Asia/Vladivostok',
    'Asia/Ust-Nera',
    'Asia/Magadan',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Kamchatka',
    'Asia/Anadyr',
    'Asia/Riyadh',
    'Pacific/Guadalcanal',
    'Indian/Mahe',
    'Africa/Khartoum',
    'Europe/Stockholm',
    'Asia/Singapore',
    'America/Paramaribo',
    'Africa/Juba',
    'Africa/Sao_Tome',
    'America/El_Salvador',
    'Asia/Damascus',
    'America/Grand_Turk',
    'Africa/Ndjamena',
    'Indian/Kerguelen',
    'Asia/Bangkok',
    'Asia/Dushanbe',
    'Pacific/Fakaofo',
    'Asia/Dili',
    'Asia/Ashgabat',
    'Africa/Tunis',
    'Pacific/Tongatapu',
    'Europe/Istanbul',
    'America/Port_of_Spain',
    'Pacific/Funafuti',
    'Asia/Taipei',
    'Europe/Kiev',
    'Europe/Uzhgorod',
    'Europe/Zaporozhye',
    'Pacific/Wake',
    'America/New_York',
    'America/Detroit',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Indiana/Indianapolis',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Vevay',
    'America/Chicago',
    'America/Indiana/Tell_City',
    'America/Indiana/Knox',
    'America/Menominee',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah',
    'America/Denver',
    'America/Boise',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Yakutat',
    'America/Nome',
    'America/Adak',
    'Pacific/Honolulu',
    'America/Montevideo',
    'Asia/Samarkand',
    'Asia/Tashkent',
    'America/Caracas',
    'Asia/Ho_Chi_Minh',
    'Pacific/Efate',
    'Pacific/Wallis',
    'Pacific/Apia',
    'Africa/Johannesburg'
  ],
  REFUND_SUPPORTING_GATEWAYS: ['stripe'],
  COMPANY_FEATURE_SETTINGS: {
    DailyCo: {
      id: 1,
      isActive: false,
      meeting_url: null,
      token: null,
      config: {
        room_name: null,
        user_name: null,
        is_owner: true,
        user_id: null,
        enable_screenshare: false
      }
    }
  },
  CUSTOM_EMAILS:{
    TYPE_REMINDER:10,
    TYPE_PARTICIPATION_CONFIRMED:20,
    TYPE_VOD_RENTAL:30,
    TYPE_VOD_RENTAL_EXPIRY:40,
    TYPE_STR:{
      10:'Event Reminder',
      20:'Event Participation Confirmed',
      30:'VOD Rental Confirmed',
      40:'VOD Rental Expiry'
    },
    TYPES:[
      {
        mail_type:10,
        mail_subject:"Reminder: The event $$EVENT_NAME$$ will start soon",
        mail_body:"<h3>Hello</h3><p><br></p><p>Please find below the details for the online event $$EVENT_NAME$$</p><p>Movie screening $$EVENT_NAME$$ begins at $$EVENT_TIME$$ on $$EVENT_DATE$$!</p><p>Click below to access the Event</p><p><br></p><p>Regards,</p><p>$$ORGANIZATION_NAME$$</p>",
        attachments:null,
        is_active:true
      },
      {
        mail_type:20,
        mail_subject:'Participation confirmed',
        mail_body:'<h3>Hello</h3><p><br></p><p>Thank you for confirming your participation in the event $$EVENT_NAME$$</p><p>The screening will take place exactly at $$EVENT_TIME$$ $$EVENT_DATE$$</p><br/><p>To access the event:</p><br/><p>Regards,</p><p><strong>$$ORGANIZATION_NAME$$</strong></p>',
        attachments:null,
        is_active:true
      },
      {
        mail_type:30,
        mail_subject:'Rental confirmed',
        mail_body:'<h3>Hello</h3><p><br></p><p>Thank you for renting the film $$EVENT_NAME$$</p><p>The film is available for you for the next $$EVENT_TIME$$ hours from the first time you click Watch</p><br/><p>To access the film:</p><br/><p>Regards,</p><p><strong>$$ORGANIZATION_NAME$$</strong></p>',
        attachments:null,
        is_active:true
      },
      {
        mail_type:40,
        mail_subject:'The movie rental period is about to end',
        mail_body:'<h3>Hello</h3><p><br></p><p>The rental period for the film $$EVENT_NAME$$ is about to end. It will remain available for the next $$EVENT_TIME$$ hours.</p><br/><p>Regards,</p><p><strong>$$ORGANIZATION_NAME$$</strong></p>',
        attachments:null,
        is_active:true
      }
    ]
  },
  QUICK_EVENT: {
    VIDEO_SOURCE: {
      SAMPLE: 'sample',
      UPLOAD: 'upload'
    },
    SAMPLE_VIDEO: {
      VIMEO: {
        title: 'Sample Video: Why Communicada? - Because it\'s a Zoom on Steroids',
        description: 'This is sample video which could be used for testing purpose',
        hlsUrl: 'https://player.vimeo.com/external/1013208036.m3u8?s=11af99bce7a45f32853e3ebbf0b4e5a5f553d1de&logging=false',
        thumbnailUrl: 'https://i.vimeocdn.com/video/1931144760-9bc0670146d9590cad0f8be84217fcadb8dead797d0fcf78f6d6d2f1fbe21934-d?mw=2200&mh=1242&q=70',
        vimeoId: 1013208036,
        fileName: 'sample-video-file.mp4',
        size: '100 MB'
      }
    }
  },
  QUCIK_EVENT_SCREENER_STATUS: {
    DRAFT: 0,
    PREPARED: 10,
    PUBLISHED: 20
  },
  SCREENER_STATUS_STR: {
    0: i18n.t('screener.quick.event.status.draft'),
    10: i18n.t('screener.quick.event.status.perepared'),
    20: i18n.t('screener.quick.event.status.published'),
    20: i18n.t('screener.quick.event.status.published')
  },
  CHAT_ROOM: {
    DEFAULT_PARTICIPANTS:10
  }
};
